import { render, staticRenderFns } from "./sharepage.vue?vue&type=template&id=28bee0ca&scoped=true"
import script from "./sharepage.vue?vue&type=script&lang=js"
export * from "./sharepage.vue?vue&type=script&lang=js"
import style0 from "./sharepage.vue?vue&type=style&index=0&id=28bee0ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bee0ca",
  null
  
)

export default component.exports